import { createContext } from 'react';

const sharedDataContext = createContext();

export default sharedDataContext;
